import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from './pages/EditPage.tsx';
import {rbacActions} from "../../config/rbac/actions.ts";
import {RestrictedRouteElement} from "../../components/RestrictedRouteElement.tsx";

export const InvoicesLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={<RestrictedRouteElement rbacAction={rbacActions.ListInvoices}>
                    <IndexPage/>
                </RestrictedRouteElement>}
            />
            <Route
                path=':id'
                element={<RestrictedRouteElement rbacAction={rbacActions.GetInvoice}>
                    <EditPage/>
                </RestrictedRouteElement>}
            />
        </Routes>
    );
};
